__turbopack_context__.v({
  "calendarIcon": "DatePickerField-module__XSwh1q__calendarIcon",
  "floatingLabel": "DatePickerField-module__XSwh1q__floatingLabel",
  "input": "DatePickerField-module__XSwh1q__input",
  "wrapper": "DatePickerField-module__XSwh1q__wrapper",
});
